import React, { SVGProps } from 'react';

import { useIconIdPrefix } from '~/components/Icons/utils/useIconIdPrefix';

const UserAdd = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  const prefix = useIconIdPrefix('UserAdd');

  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath={`url(#${prefix}-clip0_8333_694)`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 0C6.71573 0 0 6.71573 0 15V21.6667C0 29.9509 6.71573 36.6667 15 36.6667H21.6667C22.3414 36.6667 23.0058 36.6221 23.657 36.5358C25.3364 38.6465 27.9272 39.9996 30.8341 39.9996C35.8968 39.9996 40.0008 35.8955 40.0008 30.8329C40.0008 27.9256 38.6473 25.3344 36.536 23.655C36.6222 23.0045 36.6667 22.3408 36.6667 21.6667V15C36.6667 6.71573 29.9509 0 21.6667 0H15ZM33.3284 22.0097C33.3317 21.8958 33.3333 21.7814 33.3333 21.6667V15C33.3333 8.55668 28.11 3.33333 21.6667 3.33333H15C8.55668 3.33333 3.33333 8.55668 3.33333 15V21.6667C3.33333 23.935 3.98067 26.0521 5.10068 27.8433C8.06433 25.5389 11.7887 24.1667 15.8335 24.1667H20.8335C21.9898 24.1667 23.12 24.2788 24.2136 24.4928C25.8822 22.7509 28.2315 21.6663 30.8341 21.6663C31.6987 21.6663 32.5354 21.786 33.3284 22.0097ZM22.2647 27.5714C21.794 27.5242 21.3166 27.5 20.8335 27.5H15.8335C12.6089 27.5 9.63592 28.5774 7.2549 30.3918C9.315 32.2218 12.0277 33.3333 15 33.3333H21.6667C21.7819 33.3333 21.8968 33.3317 22.0112 33.3283C21.7873 32.535 21.6675 31.6979 21.6675 30.8329C21.6675 29.6841 21.8788 28.5847 22.2647 27.5714ZM10.8333 13.3333C10.8333 9.65144 13.8181 6.66667 17.5 6.66667H19.1667C22.8486 6.66667 25.8333 9.65144 25.8333 13.3333V15C25.8333 18.6819 22.8486 21.6667 19.1667 21.6667H17.5C13.8181 21.6667 10.8333 18.6819 10.8333 15V13.3333ZM17.5 10C15.6591 10 14.1667 11.4924 14.1667 13.3333V15C14.1667 16.841 15.6591 18.3333 17.5 18.3333H19.1667C21.0076 18.3333 22.5 16.841 22.5 15V13.3333C22.5 11.4924 21.0076 10 19.1667 10H17.5ZM29.1675 24.1663H32.5008V29.1663H37.5V32.4996H32.5008V37.4996H29.1675V32.4996H24.1667V29.1663H29.1675V24.1663Z"
          fill="#FF1A4B"
        />
      </g>
      <defs>
        <clipPath id={`${prefix}-clip0_8333_694`}>
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

UserAdd.displayName = 'UserAdd';

export default UserAdd;
